import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Brands from './components/Brands';
import About from './components/About';
import SpareParts from './components/SpareParts';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import SchemaOrg from '../../components/SchemaOrg';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <SchemaOrg />
      <Navbar />
      <main>
        <Hero />
        <Brands />
        <About />
        <SpareParts />
        <Services />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}